<template>
  <div class="ViewHome">

    <div class="main">

      <CenterColumn>

        <h1>The News Machine Game</h1>

        <p>
          In this game, you will play the role of an employee in an online newspaper. Your editor-in-chief; It is waiting for you to publish interesting news that will attract people's attention on the news site. Your job is to make sure you get what's going on right, and then choose how to present the news.
        </p>

        <p>
          Use your computer and mobile phone to verify information and its sources. This game will take approximately 15-20 minutes.
        </p>

        <Instruction>
          <strong>It's important to be quick when reporting, but the most important thing is to tell the truth. If you are both fast and accurate, you will get the highest score. Good luck! 🤩
        </Instruction>

        <h2>Write the name of your Online Newspaper and begin to play!</h2>

        <Interactable class="focuscolor">
          <input type="text" placeholder="Nyhetssajtens namn" v-model="name" ref="name" @keydown.enter="startGame()" maxlength="30"/>
        </Interactable>

        <ContinueButton :enabled="name.length > 0" @click.once="startGame()">Spela!</ContinueButton>

      </CenterColumn>
    </div>

    <div  v-if="players.length">

      <hr />

      <CenterColumn>
        <Highscore></Highscore>
      </CenterColumn>

    </div>

    <div>

      <hr />

      <CenterColumn>
        <h2>About The News Machine</h2>
        Concept & design: <a href="http://www.fabel.se" target="_blank">Fabel Kommunikation</a>, <a href="https://www.interaktivarum.se" target="_blank">Interaktiva rum</a>
        <br />
        Development: <a href="https://www.interaktivarum.se" target="_blank">Interaktiva rum</a>
        <br />
        In collaboration with: <a href="https://demokratiskasamtalet.se/" target="_blank">Det demokratiska samtalet</a> and <a href="https://vardemokrati.se/" target="_blank">Kommittén Demokratin 100 år.</a>
        <br /> <br />
        <router-link :to="{ name: 'Info'}">Läs mer om Nyhetsmaskinen</router-link>

      </CenterColumn>

    </div>

  </div>
</template>

<script>
// @ is an alias to /src
import CenterColumn from '@/components/CenterColumn.vue'
import Interactable from '@/components/Interactable.vue'
import Instruction from '@/components/Instruction.vue'
import ContinueButton from '@/components/ContinueButton.vue'
import Highscore from '@/components/Highscore.vue'

import { mapState } from 'vuex'

export default {
  name: 'ViewHome',
  components: {
    CenterColumn,
    Instruction,
    Interactable,
    ContinueButton,
    Highscore
  },
  computed: {
    ...mapState([
      'players'
    ]),
    ...mapState('newsroom',[
      'boss'
    ]),
    name: {
      get () { return this.$store.state.newsroom.name},
      set (value) {
        this.$store.commit('newsroom/setName', {'name':value})
      }
    }
  },
  methods: {
    startGame: function () {
      if(this.name.length > 0){
        this.$router.push({ name: 'Game'})
      }
    }
  },
  created: function () {
    this.$store.dispatch('newsroom/initNewsroom')
  },
}
</script>

<style lang="scss">

  .ViewHome {
    flex: 1;
    flex-direction: column;
    display: flex;
    padding-bottom: 50px;
  }

  .main{
    flex: 1;
  }

</style>
